import { useMemo, useState } from 'react';
import { ArticleQueue } from './pages/ArticleQueue';
import { CostDashboard } from './pages/CostDashboard';
import { Journalists } from './pages/Journalists';
import { ManualReview } from './pages/ManualReview';
import { StaffPageStatus } from './pages/StaffPageStatus';

type PageKey = 'journalists' | 'articles' | 'cost' | 'staff' | 'review';

const nav: Array<{ key: PageKey; label: string }> = [
  { key: 'journalists', label: 'Journalists' },
  { key: 'articles', label: 'Article queue' },
  { key: 'cost', label: 'Cost' },
  { key: 'staff', label: 'Staff pages' },
  { key: 'review', label: 'Manual review' }
];

export function App() {
  const [page, setPage] = useState<PageKey>('journalists');
  const title = useMemo(() => nav.find((item) => item.key === page)?.label ?? 'Journalists', [page]);

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand">
          <span className="brand-mark">FP</span>
          <div>
            <strong>FPMIS</strong>
            <span>Phase 0+1</span>
          </div>
        </div>
        <nav aria-label="Admin sections">
          {nav.map((item) => (
            <button
              className={item.key === page ? 'nav-item active' : 'nav-item'}
              key={item.key}
              onClick={() => setPage(item.key)}
              type="button"
            >
              {item.label}
            </button>
          ))}
        </nav>
      </aside>
      <main className="workspace">
        <header className="topbar">
          <div>
            <p className="eyebrow">Cloudflare D1 workspace</p>
            <h1>{title}</h1>
          </div>
          <div className="status-strip" aria-label="Pipeline status">
            <span><b>0</b> paid calls</span>
            <span><b>D1</b> bound</span>
            <span><b>Pages</b> active</span>
          </div>
        </header>
        {page === 'journalists' && <Journalists />}
        {page === 'articles' && <ArticleQueue />}
        {page === 'cost' && <CostDashboard />}
        {page === 'staff' && <StaffPageStatus />}
        {page === 'review' && <ManualReview />}
      </main>
    </div>
  );
}
